import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { CustomerPagePath } from 'views/constants/enums/pageTitle';
import { SignGateStateKey, SignGateCodeVerifierKey, SignGateAccountKey } from 'views/constants/const/SignGate';
import { useMfaLoginMutation } from 'views/utils/graphql/graphql';

const loginErrorMessage = 'ログインに失敗しました。もう一度お試しください。';

export const useMFARedirect = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [, mfaLogin] = useMfaLoginMutation();

  useEffect(() => {
    const code = searchParams.get('code');
    const state = searchParams.get('state');

    const savedState = sessionStorage.getItem(SignGateStateKey);
    const codeVerifier = sessionStorage.getItem(SignGateCodeVerifierKey);
    const account = sessionStorage.getItem(SignGateAccountKey);

    // stateが送信時と一致しない場合はCSRF等の不正なリダイレクトとして中断する
    if (!code || !state || !savedState || !codeVerifier || !account || state !== savedState) {
      navigate(CustomerPagePath.Login, {
        state: {
          errorMessage: loginErrorMessage,
        },
      });
      return;
    }

    (async () => {
      const ret = await mfaLogin({
        input: {
          Account: account,
          AuthencicateToken: code,
          CodeVerifier: codeVerifier,
          RedirectURL: process.env.REACT_APP_SCHEME_FOR_MFA + '/mfaredirect',
        },
      });

      // codeとcode_verifierは一度きりなのでtoken取得後に削除する
      sessionStorage.removeItem(SignGateStateKey);
      sessionStorage.removeItem(SignGateCodeVerifierKey);
      sessionStorage.removeItem(SignGateAccountKey);

      if (ret.data?.MFALogin?.Code === 0) {
        sessionStorage.setItem('token', ret.data.MFALogin.Token!);
        sessionStorage.setItem('last_4_digits', ret.data.MFALogin.PhoneNumber!);
        navigate(CustomerPagePath.Home);
        return;
      }

      navigate(CustomerPagePath.Login, {
        state: {
          errorMessage: ret.data?.MFALogin?.Message ?? loginErrorMessage,
        },
      });
    })();
  }, []);

  return {};
};
